<template>
  <div class="model-train-confirm-container">
    <div class="form-standard-row">
      <div class="form-standard-header">モデル名</div>
      <div class="form-standard-container">
        <div class="form-standard">{{modelInfo.modelName}}</div>
      </div>
      <div class="form-standard-action">
        <el-button type="primary" @click="onClickChangeTrain('input')">変更</el-button>
      </div>
    </div>
    <div class="form-standard-row">
      <div class="form-standard-header">学習データ</div>
      <div class="form-standard-container">
        <div class="form-train-data">
          <p v-if="modelInfo.ds.uploadFiles && modelInfo.ds.uploadFiles.length > 0">
            {{modelInfo.ds.uploadFiles.slice(-1)[0].originalFileName}}
            <template v-if="modelInfo.ds.uploadFiles.length > 1"> (+{{modelInfo.ds.uploadFiles.length - 1}})</template>
          </p>
          <template v-if="modelInfo.dataCollections">
            <template v-for="data in modelInfo.dataCollections"><p class="data-collection">+
              {{getDataCollectionName(data.dataCollectionId, data.categoryId)}}</p></template>
          </template>
        </div>
      </div>
      <div class="form-standard-action">
        <el-button type="primary" @click="onClickChangeTrain('input')">変更</el-button>
      </div>
    </div>
    <div class="form-standard-row">
      <div class="form-standard-header">目的</div>
      <div class="form-standard-container">
        <div class="form-standard">{{{'CLF': '分類', 'REG': '回帰', 'TSA': '時系列分析', 'UNS':
          '教師なし学習'}[modelInfo.categoryId]}}
        </div>
      </div>
      <div class="form-standard-action">
        <el-button type="primary" @click="onClickChangeTrain('input')">変更</el-button>
      </div>
    </div>
    <div class="form-standard-row">
      <div class="form-standard-header">データ件数</div>
      <div class="form-standard-container">
        <div class="form-standard">{{modelInfo.samples | number_format}}</div>
      </div>
      <div class="form-standard-action">　</div>
    </div>
    <template v-if="modelInfo.categoryId !== 'UNS'">
      <div class="form-standard-row">
        <div class="form-standard-header">予測対象</div>
        <div class="form-standard-container">
          <div class="form-standard">{{modelInfo.yName}}</div>
        </div>
        <div class="form-standard-action">
          <el-button type="primary" @click="onClickChangeTrain('data')">変更</el-button>
        </div>
      </div>
      <div class="form-standard-row">
        <div class="form-standard-header">データの変換</div>
        <div class="form-standard-container">
          <div class="form-standard" style="flex-wrap: wrap;">
            {{ transformerPackageName }}
          </div>
        </div>
        <div class="form-standard-action">
          <el-button type="primary" @click="onClickChangeTrain('option')">変更</el-button>
        </div>
      </div>
    </template>
    <div class="form-standard-row">
      <div class="form-standard-header">アルゴリズム</div>
      <div class="form-standard-container">
        <div class="form-standard">{{algorithmName || '　'}}</div>
      </div>
      <div class="form-standard-action">
        <el-button type="primary" @click="onClickChangeTrain('option')">変更</el-button>
      </div>
    </div>

    <form-item-container label="パスワード設定" annotation="*半角英数字4~16文字で設定可能です"
                         style="margin-top: 1rem; border-top: 1px solid #c0d5ef;">
      <field-container>
        <field-input name="model_name" v-model="password"
                     placeholder="モデルにパスワードを設定したい場合は入力してください"
                     validate="min:4|max:16|alpha_num"
                     validateLabel="パスワード"></field-input>
      </field-container>
    </form-item-container>

  </div>
</template>

<script lang="js">
import BaseTrainView from './base'
import { default as WebApiClient } from '../../../api/web'
import { Code } from '../../../api/base'
import { DATA_COLLECTION_DEFINES } from '../../../defines/data-collection'
import CommonUtil from '../../../utils/common'

export default {
  name: 'ModelTrainConfirmView',
  mixins: [BaseTrainView],
  components: {},
  props: {},
  data () {
    return {
      password: '',
      algorithmName: '',
      transformerPackageName: undefined
    }
  },
  created () {
    const trainView = this.getTrainView()
    trainView.$on('model-train', this.onClickTrain)
    trainView.$on('model-update', this.onClickUpdate)
  },
  destroyed () {
    const trainView = this.getTrainView()
    trainView.$off('model-train', this.onClickTrain)
    trainView.$off('model-update', this.onClickUpdate)
  },
  methods: {
    initialize () {
      this.getAlgorithms().then(algorithmsCategories => {
        this.getTransformers().then(TransformersPackages => {
          const algorithmSummary = this.getAlgorithmSummary(this.modelInfo.algorithm.algorithmId)
          this.algorithmName = algorithmSummary.algorithmName

          if (this.modelInfo.categoryId !== 'UNS') {
            if (CommonUtil.isNull(this.modelInfo.transformerPackage)) {
              this.getDefaultTransformerPackage().then((transformerPackage) => {
                this.modelInfo.transformerPackage = transformerPackage
                this.modelInfo.transformerPackage.transformers = transformerPackage.transformerIds.map(id => ({
                  transformerId: id,
                  use: true
                }))

                const selectedTransformerPackage = TransformersPackages.find(
                  selectedPackage => selectedPackage.packageId === transformerPackage.packageId)
                this.transformerPackageName = selectedTransformerPackage.packageName

                this.$forceUpdate()
              })
            } else {
              const selectedTransformerPackage = TransformersPackages.find(
                selectedPackage => selectedPackage.packageId === this.modelInfo.transformerPackage.packageId)
              this.transformerPackageName = selectedTransformerPackage.packageName

              this.$forceUpdate()
            }
          } else {
            this.$forceUpdate()
          }
        })
      })
    },
    onClickChangeTrain (name) {
      this.getTrainView().onClickTrainNavigationLink(name)
    },
    onClickTrain () {
      this.doTrain()
    },
    onClickUpdate () {
      this.doUpdate()
    },
    buildTrainParam () {
      const algorithm = Object.assign({}, this.modelInfo.algorithm)
      algorithm.algorithmId = this.getAlgorithmId(this.modelInfo.algorithm.algorithmId)

      // let stopWords = algorithm.hyperParams.filter(hyperParam => hyperParam.hyperParamId === "stop_words");
      // if (CommonUtil.isNotEmpty(stopWords)) {
      //   stopWords.forEach(param => {
      //     param.value = param.value.split(",");
      //   })
      // }

      if (this.modelInfo.algorithm.optimizeParams) {
        algorithm.hyperParams = [
          {
            hyperParamId: 'optimize_params',
            value: 1
          }, {
            hyperParamId: 'seed',
            value: 1
          }]
      } else {
        if (CommonUtil.isNotEmpty(algorithm.hyperParams)) {
          algorithm.hyperParams = algorithm.hyperParams.filter(
            (hyperParam) => hyperParam.hyperParamId !== 'update_only_model')
        }
      }

      const xExcept = this.modelInfo.xExcept.filter(value => value !== this.modelInfo.yName)
      const ds = this.modelInfo.ds

      let transformers = CommonUtil.isNotEmpty(this.modelInfo.transformerPackage)
        ? this.modelInfo.transformerPackage.transformers
        : []
      if (CommonUtil.isEmpty(transformers) && this.modelInfo.categoryId !== 'UNS') {
        transformers = this.modelInfo.transformerPackage.transformerIds.map(id => ({ transformerId: id }))
      } else {
        transformers = transformers.filter(transformer => transformer.use === true)
      }

      return {
        modelName: this.modelInfo.modelName,
        purposeId: this.modelInfo.categoryId,
        categoryId: this.getAlgorithmCategoryId(this.modelInfo.algorithm.algorithmId),
        dsName: CommonUtil.isNotEmpty(ds.dsName) ? [ds.dsName] : this.modelInfo.ds.uploadFiles.map(
          uploadFile => uploadFile.dsName),
        xType: this.modelInfo.xType,
        yName: this.modelInfo.yName,
        xExcept: xExcept,
        transformerPackageId: this.modelInfo.categoryId !== 'UNS'
          ? this.modelInfo.transformerPackage.packageId
          : null,
        transformers: transformers,
        algorithm: algorithm,
        deleteUploadFile: this.modelInfo.deleteUploadFile,
        dataCollection: {
          possibilities: this.modelInfo.possibilities,
          joinedData: this.modelInfo.dataCollections
        },
        password: this.password
      }
    },
    buildUpdateParam () {
      return Object.assign(this.buildTrainParam(), {
        updatedAt: this.modelInfo.updatedAt
      })
    },
    doTrain () {
      const param = this.buildTrainParam()
      WebApiClient.postModels(this, param).then(this.handleTrainAndUpdateResponse)
    },
    doUpdate () {
      const param = this.buildUpdateParam()
      WebApiClient.putModel(this, this.modelInfo.modelId, param).then(this.handleTrainAndUpdateResponse)
    },
    handleTrainAndUpdateResponse (response) {
      const code = response.data.code
      if (code === Code.SUCCESS) {
        this.changeLocation('model-detail', {
          modelId: response.data.result.modelId
        })
      } else if (code === Code.TIMEOUT) {
        this.changeLocation('model-list')
      }
    },
    getDataCollectionName (dataCollectionId, categoryId) {
      const data = DATA_COLLECTION_DEFINES.filter(data =>
        data.dataCollectionId === dataCollectionId && data.categoryId === categoryId
      )[0]

      if (data.categoryId) {
        return data.dataCollectionName + ' ' + data.categoryName
      } else {
        return data.dataCollectionName
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  .model-train-confirm-container {
    max-width: 1000px;
    padding: 24px;
    height: 100%;
  }

  .model-train-confirm-container > .form-standard-row {
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    border-left: 1px solid #c0d5ef;
    border-right: 1px solid #c0d5ef;
    border-bottom: 1px solid #c0d5ef;
    min-height: 80px;
  }

  .model-train-confirm-container > .form-standard-row:first-child {
    border-top: 1px solid #c0d5ef;
  }

  .model-train-confirm-container > .form-standard-row > .form-standard-header {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    text-align: left;
    background: #6ba7ef;
    width: 218px;
    color: #fff;
    padding: 20px;
    font-weight: 700;
  }

  .model-train-confirm-container > .form-standard-row > .form-standard-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    padding: 14px;
    flex-grow: 1;
    overflow-x: hidden;
  }

  .model-train-confirm-container > .form-standard-row > .form-standard-action {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: 100px;
    border-left: 1px solid #c0d5ef;
  }

  .model-train-confirm-container > .form-standard-row > .form-standard-container > .form-standard {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: left;
    background: #fff;
    border: none;
  }

  .model-train-confirm-container > .form-standard-row > .form-standard-container > .form-train-data {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    background: #fff;
    border: none;
  }

  .model-train-confirm-container > .form-standard-row > .form-standard-container > .form-train-data > .data-collection {
    margin-left: 1em;
    margin-bottom: 0;
    font-size: 80%;
  }

</style>



// WEBPACK FOOTER //
// src/views/model/train/confirm.vue